module.exports = __webpack_public_path__ + "static/media/COS_MAYOLY_TOPICREM.4ce726a0.png";